export default __webpack_public_path__ + "static/media/parallax-bg39.92a68232.jpg";